import { render, staticRenderFns } from "./DocumentPrintSales.vue?vue&type=template&id=71a6f6d4&scoped=true"
import script from "./DocumentPrintSales.vue?vue&type=script&lang=js"
export * from "./DocumentPrintSales.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintSales.vue?vue&type=style&index=0&id=71a6f6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6f6d4",
  null
  
)

export default component.exports